<div [class]="{'invalid-deadweight': isCargoDeltaExceedingDeadWeight()}">
  <h6 class="bert-visit-header mb-4">{{ berthVisit()?.berth?.name }}</h6>
  <div class="row g-4">
    @if (isCargoDeltaExceedingDeadWeight()) {
      <app-alert summary="Combined weight exceeds dead weight"
                icon="fa-circle-xmark"
                [severity]="AlertSeverity.DANGER"
                class="col-12 mt-3 validation-deadweight">
        Combined weight of cargo on berth visit cannot exceed {{ vesselDeadWeightTons() | number: '1.0-3' : 'nl' }} tons
      </app-alert>
    }
    <app-form-field
        class="col-12 col-md-4 mt-2"
        label="Arrival date & time"
        [includeMargin]="false"
        [value]="berthVisit()?.ata | date:'d MMM y, HH:mm'"
        [editMode]="false" />
    <app-form-field
        class="col-12 col-md-8 mt-2"
        label="Stay duration"
        [includeMargin]="false"
        [value]="berthVisitDuration()"
        [editMode]="false" />
    <app-berth-visit-tabs-rotterdam
        [berthVisitNumber]="berthVisitNumber()"
        [berthVisit]="berthVisit()"
        [harbourDuesDetails]="harbourDuesDetails()"
        [showValidationErrors]="showValidationErrors()" />
  </div>
</div>
